<template style="height: 100%">
  <article class="message menuCreateProcess">
    <div class="message-body" style="height: 100%">
      <div class="has-text-right">
        <button class="delete" aria-label="delete" v-on:click="close"></button>
      </div>
      <!-- First part -->
      <div class="has-text-centered">
        <!-- Title -->
        <div
          class="heading is-size-6 border"
          style="padding-top: 5px; margin-top: 15px; text-transform: capitalize;"
        >
          <!-- Text -->
          <div class="is-size-2">
            {{ this.process._id ? "Actualizar" : "Crear" }} Proceso
          </div>
        </div>
      </div>
      <br />
      <div class="box">
        <span class="is-size-7"
          >Los siguientes datos solicitados en el formulario se usará para
          construir el nombre del proceso. Ingresa la fecha correcta del
          proceso, con ello identificaremos los procesos más actualizados.</span
        >
      </div>
      <div style="margin-top: 40px;">
        <div>
          <label for="name"
            >Nombre del proceso<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <input
                class="input"
                :class="errors.name.type"
                v-model="process.name"
                type="text"
                id="name"
                name="name"
                placeholder="Nombre del nuevo proceso"
              />
            </div>
          </div>
          <span
            v-if="errors.name.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.name.message }}</span
          >
        </div>
        <br />
        <div class="columns">
          <div class="column is-6">
            <label for="group"
              >Nombre del grupo<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.group.type"
                  v-model="process.group"
                  type="text"
                  id="group"
                  name="group"
                  placeholder="Nombre del grupo"
                />
              </div>
            </div>
            <span
              v-if="errors.group.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.group.message }}</span
            >
          </div>
          <div class="column is-6">
            <label for="created"
              >Fecha de creación<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.created.type"
                  type="date"
                  v-model="process.created"
                  id="created"
                  name="created"
                  placeholder="Fecha de creación"
                />
              </div>
            </div>
            <span
              v-if="errors.created.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.created.message }}</span
            >
          </div>
        </div>
        <div v-if="type" class="option-benchmark">
          <label class="has-text-weight-bold">Benchmark</label>
          <b-field style="margin-top: 10px;">
            <b-radio-button
              v-model="process.benchmark"
              :native-value="0"
              type="is-danger"
            >
              <b-icon icon="database-minus-outline"></b-icon>
              Excluido
            </b-radio-button>
            <b-radio-button
              v-for="(option, key) in optionsBenchmark[type]"
              :key="key"
              v-model="process.benchmark"
              :native-value="option.value"
              :type="option.type"
            >
              <b-icon :icon="option.icon"></b-icon>
              <span>{{ option.label }}</span>
            </b-radio-button>
          </b-field>
        </div>
        <div
          class="actions-footer has-background-white"
          style="position: absolute; bottom: 10px; width: 100%;"
        >
          <div class="is-flex">
            <button
              class="button is-danger is-outlined"
              style="margin-right: 5px"
              v-on:click="close"
            >
              Cancelar
            </button>
            <button class="button is-dark" v-on:click="createNewProcess">
              {{ process._id ? "Actualizar" : "Guardar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import apiServices from "@/services/yungol-services";

export default {
  data() {
    return {
      process: {
        name: "",
        group: "",
        created: null,
        benchmark: 0,
      },
      errors: {
        name: {},
        group: {},
        created: {},
      },
      errorsCont: 0,
      optionsBenchmark: {
        lid: [
          {
            label: "Empresa",
            icon: "office-building",
            type: "is-info",
            value: 1,
          },
          {
            label: "Solo líderes",
            icon: "account-star",
            type: "is-success",
            value: 2,
          },
        ],
        cl7: [
          {
            label: "Incluido",
            icon: "database-plus-outline",
            type: "is-success",
            value: 1,
          },
        ],
      },
    };
  },
  props: {
    data: Object,
    hasBenchmark: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("closeMenuCreate");
    },
    async createNewProcess() {
      let result;
      try {
        if (this.validateForm()) {
          const data = {
            nombre: `${this.process.name} - ${
              this.process.group
            } - ${this.formatDateForName(this.process.created)}`,
            newProcess: this.process,
          };
          if (this.process._id) data._id = this.process._id;

          if (this.hasBenchmark && this.process.benchmark === 1) {
            const config = {
              title: "¿Estás seguro?",
              text:
                "Ya hay un proceso seleccionado para el benchmark. Si continúas, este proceso lo reemplazará.",
              icon: "warning",
              showCancelButton: true,
              cancelButtonColor: "#de5b5b",
              confirmButtonText: "Sí, reemplazar proceso",
            };

            await this.$swal(config).then(async (result) => {
              if (!result.isConfirmed) {
                this.process.benchmark = 0;
              }
            });
          }

          switch (this.type) {
            case "lid":
              result = await apiServices.post(`/createliderproceso`, data);
              break;
            case "cl7":
              result = await apiServices.post(`/cretecohorteclima`, data);
              break;
          }
          if (result.data) {
            await this.$store.dispatch("notify", {
              message: `Perfecto!. Proceso ${data.id ? "Editado" : "Creado"}.`,
            });
            this.clearAllForm();
            this.close();
            this.$emit("getProcesses");
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    validateForm() {
      this.errors = {
        name: {},
        group: {},
        created: {},
      };
      const process = this.process;
      let valid = true;
      if (process.name === "" || process.name === null) {
        this.errors.name.message = "El nombre es requerido.";
        this.errors.name.type = "is-danger";
        valid = false;
      }
      if (process.group === "" || process.group === null) {
        this.errors.group.message = "El grupo es requerido.";
        this.errors.group.type = "is-danger";
        valid = false;
      }
      if (process.created === "" || process.created === null) {
        this.errors.created.message = "La fecha es requerida.";
        this.errors.created.type = "is-danger";
        valid = false;
      }

      if (!valid) {
        this.errorsCont++;
      }
      return valid;
    },
    clearAllForm() {
      this.process = {
        name: "",
        group: "",
        created: null,
      };
      this.errors = {
        name: {},
        group: {},
        created: {},
      };
      this.errorsCont = 0;
    },
    formatDateForName(d) {
      let date = new Date(d);
      date.setHours(date.getHours() + 12);
      let options = { day: "numeric", month: "long", year: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
  },
  created() {
    if (Object.keys(this.data).length) {
      const { _id, nombre, created, benchmark } = this.data;
      const [name, group] = nombre.split(" - ");
      this.process = {
        _id,
        name: name || "",
        group: group || "",
        created: created ? created.split("T")[0] : null,
        benchmark: benchmark || 0,
      };
    }
  },
  watch: {
    process: {
      handler() {
        if (this.errorsCont) {
          this.validateForm();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.menuCreateProcess {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow: scroll;
  border-radius: 0 0 0 0 !important;
}

.menuCreateProcess .actions-footer {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
}

.menuCreateProcess .field {
  margin-bottom: 0;
}

.option-benchmark {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/menuCreateProcess.vue